export const localesObjectToMessages = (items, locale) => {
  return Object.entries(items).reduce((acc, item) => {
    return {
      ...acc,
      [item[0]]: {
        [locale]: item[1],
      },
    };
  }, {});
};
